export { default as SpecsList } from "./specs-list/specs-list";
export { default as Price } from "./price/price";
export { default as Subtitle } from "./subtitle/subtitle";
export { default as Title } from "./title/title";
export { default as ProductImage } from "./product-image/product-image";
export { default as Card } from "./card/card";
export { default as AdminFeeButton } from "./admin-fee-button/admin-fee-button";
export { default as FavouriteCTA } from "./favourite-cta/favourite-cta";
